import { render } from "./Tab.vue?vue&type=template&id=6dcbcb6b&scoped=true&ts=true"
import script from "./Tab.vue?vue&type=script&lang=ts"
export * from "./Tab.vue?vue&type=script&lang=ts"

import "./Tab.vue?vue&type=style&index=0&id=6dcbcb6b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcbcb6b"]])

export default __exports__